import {Component, OnDestroy, OnInit} from '@angular/core';
import {UtilsService} from '../../../../core/utils/utils.service';
import {Auth2Service} from '../../../../core/services/security/auth2.service';
import {RoutemapService} from '../../../../core/services/routemap.service';

import {DialogMsgSupplier, Paragraphe} from '../../../../core/suppliers/dialog-msg-supplier';
import {GenericManageDialogService} from '../../../../core/services/generics/generic-manage-dialog.service';
import {Subscription} from 'rxjs';
import {GenericDatagridService} from "../../../../core/services/generics/generic-datagrid.service";
import {StockMouvementStatutDTO} from "../../../../core/dtos/stock-mouvement-statut-dto";
import {
  StatutSavedSupplier,
  StockMouvementStatutService
} from "../../../../core/services/gestion-stock/stock-mouvement-statut.service";
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {InternationalizationService} from "../../../../core/services/i8n/i8n.service";
import {confirm} from "devextreme/ui/dialog";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';
import {IsDeletableObject} from "../../../../core/models/is-deletable-object";
import {CoreErrorModel} from "../../../../core/models/technique/errors/core-error-model";

@Component({
    selector: 'yo-grille-statuts',
    templateUrl: './grille-statuts.component.html',
    styleUrls: ['./grille-statuts.component.scss'],
    standalone: false
})
export class GrilleStocksMouvementsStatutComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  statutsList: StockMouvementStatutDTO[] = [];

  hasGestion = false;

  subStatutSaved: Subscription;

  allMode: string;
  checkBoxesMode: string;
  selectedRows: number[] = [];

  errors: { infosLine: string }[] = [];
  displayDeletePopupErrors = false;

  pathFile: string = HELP_FOLDERS.REFERENTIEL + '/status';

  constructor(public utils: UtilsService,
              private auth2Svc: Auth2Service,
              private routeMapSvc: RoutemapService,
              private genericManageDialogService: GenericManageDialogService,
              public gds: GenericDatagridService,
              private smsSvc: StockMouvementStatutService,
              private i18nSvc: InternationalizationService,
              private toastSvc: ToastService) {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'always'
  }

  ngOnInit(): void {
    this.initValues();
    this.initHasGestionStocks();
    this.valueSavedSubscription();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subStatutSaved);
  }

  initValues = (): void => {
    this.smsSvc.getAll()
      .subscribe(response => {
        this.statutsList = response.resultList;
      });
  };

  initHasGestionStocks = (): void => {
    this.auth2Svc.hasStocks$.subscribe(response => this.hasGestion = response);
  };

  canEdit = (): boolean => this.auth2Svc.hasSitesLocaux() && this.hasGestion;

  calculateSiteValue = (st: StockMouvementStatutDTO): string => {
    return st?.labelSite;
  };

  closeErrors = (): void => {
    this.errors = [];
    this.displayDeletePopupErrors = false;
  };

  deleteValues = async (): Promise<void> => {
    const idsToDelete: number[] = [...this.selectedRows];
    if (!idsToDelete.length) return;

    const isDeletionValidated: boolean = await confirm(
      this.i18nSvc.getLabelFromCode(idsToDelete.length > 1 ? 'CONFIRM_DELETION_PLURAL' : 'CONFIRM_DELETION_SINGULAR', null),
      this.i18nSvc.getLabelFromCode('Suppression', null));

    if (!isDeletionValidated) return;

    this.smsSvc.deleteByIds(idsToDelete)
      .subscribe(response => {
        const res: IsDeletableObject = response.one;
        const errorList: CoreErrorModel[] = res?.messagesErrorList ?? [];
        const deletedCount: number = idsToDelete.length - errorList.length;

        if (deletedCount > 0) {
          this.selectedRows = [];
          this.initValues();
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS,
            this.i18nSvc.getLabelFromCode(deletedCount > 1 ? 'DELETION_COMPLETED_PLURAL' : 'DELETION_COMPLETED_SINGULAR', null));
        }

        if (errorList.length) {
          this.errors = errorList.map(error => ({
            infosLine: this.i18nSvc.getLabelFromCode(error.code, error.args ? [error.args] : [])
          }));
          this.displayDeletePopupErrors = true;
        }
      });
  };

  valueSavedSubscription = (): void => {
    this.subStatutSaved = this.smsSvc.statutSaved$
      .subscribe((response: StatutSavedSupplier) => {
        this.initValues();
      });
  };

  open = (s: StockMouvementStatutDTO): void => {
    this.smsSvc.announceOpenDialogStatut(s);
  };

  public help = (): DialogMsgSupplier => {
    const dms = new DialogMsgSupplier();
    dms.title = `Les statuts de stocks de mouvements`;
    dms.logo = 'fa fa-question-circle  yoni-color';
    const p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [];

    dms.content = {
      intro: ``,
      paragraphes: []
    };

    return dms;
  };

}
